import PropTypes from 'prop-types';
import { forwardRef } from 'react';

const CheckboxBase = forwardRef(
  ({ id, name, className = '', defaultChecked, hasError = false, readOnly = false, ...props }, ref) => {
    return (
      <input
        type="checkbox"
        ref={ref}
        id={id}
        readOnly={readOnly}
        name={name}
        className={`
        checkbox
        ${className}
        ${hasError ? 'input-error' : ''}
        ${defaultChecked ? 'defaultChecked' : ''}

      `}
        {...props}
      />
    );
  },
);

CheckboxBase.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  defaultChecked: PropTypes.bool,
  type: PropTypes.string,
  className: PropTypes.string,
  isDefault: PropTypes.bool,
  readOnly: PropTypes.bool,
  hasError: PropTypes.bool,
};

CheckboxBase.displayName = 'CheckboxBase';

export default CheckboxBase;
